<template lang="pug">
  .contact-ctas-section
    SupportCtas
</template>

<script>
  import MrIcon from '@components/MrIcon';
  import SupportCtas from '../SupportCtas';

  export default {
    name: 'ExpertiseIncluded',

    components: {
      SupportCtas,
      MrIcon,
    },
  };
</script>

<style scoped lang="stylus">
  .contact-ctas-section
    display flex
    flex-direction column
    align-items center

    @media mq-mobile
      padding 1em 0.5em

    .video-chat-cta
      width 100%
      .mr-btn
        padding 0.5em 2em
        width 100%
        .camera-icon
          margin-right 1em
</style>